<div class="d-flex align-items-center py-4 bg-body-tertiary vh-100">
    <main class="form-signin w-100 m-auto">
        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
            <img class="mb-3 bi-align-center logo" ngSrc="/assets/logo_color_login.png" alt="VineMeds" width="200" height="57" priority>
            <div class="h5 mb-3">Forgot password</div>
            <div class="fs-6 mb-3">
                After submitting, you should receive an email with instructions to reset your password.
            </div>

            <div class="form-floating my-3">
                <input type="email" class="form-control shadow-none" id="emailControl" formControlName="email">
                <label for="emailControl">Email address</label>
            </div>

            <button [disabled]="loading" class="btn btn-primary w-100 py-2">
                @if (loading) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                }
                Submit
            </button>

            <p class="mt-5 text-body-secondary">&copy; 2022–2024</p>
        </form>
    </main>
</div>
